module.exports = __webpack_public_path__ + "static/media/team_3.5877a1bb.png";